import {GET_ANNUAL} from '../Actions/types'

const initialState= { 
    monthsInYear: "",

}

export default function (state = initialState, action) {

        switch(action.type) {
            case GET_ANNUAL: 
                return{
                    ...state,
                    monthsInYear: action.payload
                };
                default: 
            return state;

        }
    }



// WEBPACK FOOTER //
// ./src/Reducers/AnnualChartReducer.js